import { BasicIdentity, existsWithId, MayHaveId, Selectable } from '../types';

export const makeSelectables = <T extends MayHaveId>(items: T[], selectedIds: BasicIdentity[]): Selectable<T>[] =>
  items.map(item => ({
    item,
    selected: existsWithId(item) ? selectedIds.includes(item['id']) : false,
  }));
